export function FitlineLogo() {
  return (
    <img
      className="h-14 flex-none"
      src="https://cdn.pm-international.com/assets-shared-frontend/company-logos/fitline.svg"
      alt="Fitline Logo"
    />
  );
}
